import React from "react"
import styled from "styled-components"

export default class extends React.Component {
  render() {
    const { icon, type, padding = 0, ...rest } = this.props
    const PButton = styled.button`
      border: none;
      background: ${
          type === "green"
        ? "#69b823"
        : "black"
      };
      color: white;
      border-radius: 3px;

      &:hover {
        background: ${
            type === "green"
          ? "rgb(82, 175, 0)"
          : "none"
        };
      }
    `

    return (
      <PButton {...rest}>
        {this.props.children}
      </PButton>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/PButton/index.js